import { useContext } from 'react';
import { MuteContext, MuteContextValue } from '@/context/MuteContext';

export const useMute = (): MuteContextValue => {
    const value = useContext(MuteContext());
    if (!value) {
        throw new Error('useMute must be used within a MuteProvider');
    }

    return value;
};
